import React from 'react';
import { Check, RotateCcw } from 'lucide-react';

interface ThemeManagerToastsProps {
  showSuccess: boolean;
  showResetSuccess: boolean;
  error: string | null;
  onDismissError: () => void;
}

export const ThemeManagerToasts: React.FC<ThemeManagerToastsProps> = ({
  showSuccess,
  showResetSuccess,
  error,
  onDismissError,
}) => {
  return (
    <>
      {/* Success Toast */}
      {showSuccess && (
        <div className="fixed top-20 right-4 z-50 bg-green-50 border border-green-200 rounded-lg p-4 shadow-lg">
          <div className="flex items-center space-x-2">
            <Check className="h-5 w-5 text-green-600" />
            <p className="text-green-800 font-medium">Theme saved successfully!</p>
          </div>
        </div>
      )}

      {/* Reset Success Toast */}
      {showResetSuccess && (
        <div className="fixed top-20 right-4 z-50 bg-blue-50 border border-blue-200 rounded-lg p-4 shadow-lg">
          <div className="flex items-center space-x-2">
            <RotateCcw className="h-5 w-5 text-blue-600" />
            <p className="text-blue-800 font-medium">Theme reset to defaults!</p>
          </div>
        </div>
      )}

      {/* Error Toast */}
      {error && (
        <div className="fixed top-20 right-4 z-50 bg-red-50 border border-red-200 rounded-lg p-4 shadow-lg">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <span className="text-red-600">⚠️</span>
              <p className="text-red-800 font-medium">{error}</p>
            </div>
            <button onClick={onDismissError} className="ml-4 text-red-600 hover:text-red-800">
              ✕
            </button>
          </div>
        </div>
      )}
    </>
  );
};
